import {all, call, fork, put, takeEvery, select} from 'redux-saga/effects';
import {apiClient} from '../../../shared/api';

import {
    GET_FOLDER_PERMISSION
} from './constants';

import {
    getFolderPermissionFailed,
    getFolderPermissionSuccess,
} from './actions';

import {Endpoint} from '../../documents/constants';

const getState = (state) => {
    return state.GeneralSettings
};

function* getFolderPermission(refresh?) {
    const state = yield select(getState);
    if (!state.folderPermission.firstTime) {
        const response = yield call(apiClient.list, `${Endpoint.Folder}/permissions`);
        if (response.error) {
            yield put(getFolderPermissionFailed(response.detail));
        } else {
            yield put(getFolderPermissionSuccess(response.data));
        }
    }
}

export function* watchgetFolderPermission(): any {
    yield takeEvery(GET_FOLDER_PERMISSION, getFolderPermission);
}

function* settingCoreSaga(): any {
    yield all([
        fork(watchgetFolderPermission),
    ]);
}

export default settingCoreSaga;